import { useFormik } from 'formik';

export const useForm = (props) => {
  const formik = useFormik({
    ...props,
    enableReinitialize: true,
  });

  return {
    formik,
    onSubmit: formik.handleSubmit,
    onChange: formik.handleChange,
    onBlur: formik.handleBlur,
    values: formik.values,
    errors: formik.errors,
    touched: formik.touched,
    setFieldValue: formik.setFieldValue,
    isSubmitting: formik.isSubmitting,
    resetForm: formik.resetForm,
  };
};
